import api from "../apiInstance";
import { AdvertListModel, AdvertModel, AdvertPublicListModel, CreateAdvertModel, UpdateAdvertModel } from "./interfaces/Advert";

export const listAdverts = async (): Promise<AdvertListModel[]> => {
    const res = await api.get<AdvertListModel[]>(process.env.REACT_APP_RENTIC_API_URL! + '/advert/list');

    return res.data;
}

export const getAdvertsPublic = async (): Promise<AdvertPublicListModel[]> => {
    const res = await api.get<AdvertPublicListModel[]>(process.env.REACT_APP_RENTIC_API_URL! + '/advert/list_public');

    return res.data;
}

export const addAdvert = async (data: CreateAdvertModel): Promise<AdvertModel> => {
    const res = await api.post<AdvertModel>(process.env.REACT_APP_RENTIC_API_URL! + '/advert/create', data);

    return res.data;
}

export const getAdvertDetails = async (advertId: number): Promise<AdvertModel> => {
    const res = await api.get<AdvertModel>(process.env.REACT_APP_RENTIC_API_URL! + '/advert/' + advertId.toString());

    return res.data;
}

export const updateAdvert = async (advertId: number, data: UpdateAdvertModel): Promise<boolean> => {
    const res = await api.patch<boolean>(process.env.REACT_APP_RENTIC_API_URL! + '/advert/' + advertId.toString(), data);

    return res.data;
}

export const deleteAdvert = async (advertId: number): Promise<boolean> => {
    const res = await api.delete<boolean>(process.env.REACT_APP_RENTIC_API_URL! + '/files/delete_advert_pic/' + advertId.toString());
    const res2 = await api.delete<boolean>(process.env.REACT_APP_RENTIC_API_URL! + '/advert/' + advertId.toString());

    return res2.data;
}